import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31c42dd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-item-wrapper" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "nav-item__icon-wrapper" }


import stateLayer from '@/common/components/helper-components/state-layer/state-layer.vue';
import googleMaterialIcon from '@/common/components/helper-components/google-material-icon/google-material-icon.vue';
import { INavItemProps } from './navigation-item.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'navigation-item',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(['nav-item', __props.props.selected ? 'nav-item_selected' : '']),
      href: "#",
      title: __props.props.title
    }, [
      _createVNode(stateLayer, { class: "nav-item__state-layer" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(googleMaterialIcon, {
              props: {
                            iconName: __props.props.iconName,
                            color: __props.props.selected
                                ? 'var(--snotra--sys--on-secondary-container)'
                                : 'var(--snotra--sys--on-surface-variant)',
                            selected: __props.props.selected,
                        },
              "icon-name": __props.props.iconName,
              class: "nav-item__icon"
            }, null, 8, ["props", "icon-name"])
          ])
        ]),
        _: 1
      })
    ], 10, _hoisted_2)
  ]))
}
}

})